import axios from "axios";
import GeoServer from "../../../service/geoserser";

export default async function pullLocality(layername,filter='1=1'){
    return axios.get(GeoServer.API_URL+'/ows?cql_filter='+filter+'&service=WFS&version=1.0.0&request=GetFeature&typeName='+layername+'&outputFormat=application%2Fjson')

}